// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__+4gIe","listRequirement":"Detail_listRequirement__1quQe"};